import {TrackableEntity} from './../data/ChangeTrackable';
import {AmsContainer} from './AmsContainer';

export class AmsMbl extends TrackableEntity {
    id: number = 0;
    mblNo: string = '';
    fsCompanyId: number = 0;
    eta: string | null = null;
    onBoard: string | null = null;
    loadEtd: string | null = null;
    convRefNo: string = '';
    svcBulletNo: string = '';
    vesselName: string = '';
    voyage: string = '';
    origin: string = '';
    loadPort: string = '';
    dCode: string = '';
    vesselFlag: string = '';
    lfp: string = '';
    pou: string = '';
    manifestSeq: string = '';
    svcNo: string = '';
    mCommodity: string = '';
    feederVessel: string = '';
    fCode: string = '';
    finalDest: string = '';
    moveType: string = '';
    n1Scac: string = '';
    n2Scac: string = '';
    coload: boolean = false;
    coloadBlNo: string = '';
    lclFcl: string = '';
    expRls: boolean = false;
    branch: string = '';
    caType: string = '';
    cntrId: number = 0;
    cntrNo: string = '';
    cntrType: string = '';
    sealNo1: string = '';
    sealNo2: string = '';
    acctID: string = '';
    acDesc: string = '';
    preRevenue: number = 0;
    preCost: number = 0;
    colRevenue: number = 0;
    colCost: number = 0;
    lloyds: string = '';
    amsUserId: number = 0;
    userName: string = '';
    lPortName: string = '';
    dPortName: string = '';
    carrierName1: string = '';
    container: AmsContainer[] = [];

    constructor(init?:Partial<AmsMbl>) {
        super();
        this.key='id';
        Object.assign(this, init);
        if(this.id === 0) this.id = this.GetNextId();

        if(this.container.length > 0) {
            this.container = this.container.map(d => new AmsContainer(d));
        } else {
            this.container = [];
        }
    }
}
